import type { ReactNode } from "react";
import { useRegion, type Region } from "./useRegion";

type Props = {
  regions: Region[];
  fallback?: ReactNode;
  children: ReactNode;
};

export function RegionGate({ regions, fallback = null, children }: Props) {
  const region = useRegion();
  if (!regions.includes(region)) return fallback;
  return children;
}
